import React from 'react'
import PropTypes from 'prop-types'
import withStyles from 'isomorphic-style-loader/withStyles'
import * as styles from './_ContactPage.scss'
import ContactAnAdviserContainer from '../../features/ContactAnAdviser/ContactAnAdviserContainer'
import AdviserContactDetailsContainer from '../../features/AdviserContactDetails/AdviserContactDetailsContainer'
import { Row, Col } from 'react-bootstrap'

class ContactPage extends React.Component {
  static propTypes = {
    adviserId: PropTypes.number.isRequired,
    adviserName: PropTypes.string.isRequired
  }

  render () {
    return (
      <Row>
        <Col xs={12} sm={12} md={12} lg={12}>
          <Row className={styles['vertical-fill-container']} >
            <Col xs={12} sm={12} md={8} lg={8} className={styles['left-non-vertical-fill']}>
              <ContactAnAdviserContainer adviserName={this.props.adviserName} adviserId={this.props.adviserId} />
            </Col>
            <Col md={4} lg={4} className={`d-none d-sm-block ${styles['adviser-details-well']}`}>
              <AdviserContactDetailsContainer adviserId={this.props.adviserId} className={styles['right-vertical-fill-element']} />
            </Col>
          </Row>
          <Row>
            <Col xs={12} sm={12} className={`d-sm-none ${styles['left-non-vertical-fill']}`} >
              <AdviserContactDetailsContainer adviserId={this.props.adviserId} />
            </Col>
          </Row>
        </Col>
      </Row>
    )
  }
}

export default  (ContactPage)
